import { render, staticRenderFns } from "./MRStats.vue?vue&type=template&id=63dd7228&"
import script from "./MRStats.vue?vue&type=script&lang=js&"
export * from "./MRStats.vue?vue&type=script&lang=js&"
import style0 from "./MRStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports